if (!customElements.get('ondelie-hero')) {
  customElements.define(
    'ondelie-hero',
    class OndelieHero extends HTMLElement {
      constructor() {
        super();
        this.variantButtons = [];
        this.onVariantChange = this.handleVariantChange.bind(this);
      }

      connectedCallback() {
        this.variantButtons = Array.from(this.querySelectorAll('[data-oh-variant]'));
        this.classList.add('is-mounted');

        this.variantButtons.forEach((button) => {
          button.addEventListener('click', this.onVariantChange);
        });

        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.classList.add('is-visible'));
        });
      }

      handleVariantChange(event) {
        const selected = event.currentTarget;
        const variantInput = this.querySelector('[data-oh-variant-input]');
        const price = this.querySelector('[data-oh-price]');
        const comparePrice = this.querySelector('[data-oh-compare-price]');
        const productImage = this.querySelector('[data-oh-product-image]');
        const addButton = this.querySelector('[data-add-to-cart]');
        const addButtonText = this.querySelector('[data-add-to-cart-text]');
        const isAvailable = selected.dataset.available === 'true';

        this.variantButtons.forEach((button) => {
          const isSelected = button === selected;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        if (variantInput) variantInput.value = selected.dataset.variantId;
        if (price) price.textContent = selected.dataset.price;

        if (comparePrice) {
          comparePrice.textContent = selected.dataset.comparePrice || '';
          comparePrice.hidden = !selected.dataset.comparePrice;
        }

        if (productImage && selected.dataset.image) {
          productImage.removeAttribute('srcset');
          productImage.src = selected.dataset.image;
        }

        if (addButton) addButton.disabled = !isAvailable;
        if (addButtonText) {
          addButtonText.textContent = isAvailable
            ? addButtonText.dataset.availableText
            : addButtonText.dataset.soldOutText;
        }
      }

      disconnectedCallback() {
        this.variantButtons.forEach((button) => {
          button.removeEventListener('click', this.onVariantChange);
        });
      }
    }
  );
}
